import axios from '../../config/axios';
import router from '../../router';
import {post} from '@/services/api.service';
import ErrorHandler from '../../config/ErrorHandler';

const state = {
  token: null,
  userData: {},
};

const mutations = {
  setToken(data, payload) {
    data.token = payload.data.token;
    localStorage.setItem('TOKEN', payload.data.token);
  },
  setUser(data, payload) {
    data.userData = payload;
    localStorage.setItem('USERDATA', JSON.stringify(payload));
  },
  clearPermissions(data) {
    data.token = null;
    data.userData = {};
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('USERDATA');
  },
};

const getters = {
  getUserName: data => `${data.userData.name} ${data.userData.surname}`,
  getUserRole: data => data.userData.type,
  getUserId: data => data.userData.id,
};

const actions = {
  login(context, payload) {
    return new Promise((resolve) => {
      post('/login', payload)
        .then((response) => {
          axios.defaults.headers.Authorization = `Bearer ${response.data.token}`;
          context.commit('setToken', response);
          context.commit('setUser', response.data.user);
          resolve();
        }, () => {
        ErrorHandler.popup('Błąd logowania');
        });
    });
  },
  sendEmail(context, payload) {
    return new Promise((resolve) => {
      post('/password/create_reset', payload)
        .then(() => {
          resolve();
        });
    });
  },
  resetPassword(context, payload) {
    return new Promise((resolve) => {
      post('/password/reset', payload)
        .then(() => {
          resolve();
        });
    });
  },
  logout(context) {
    return new Promise((resolve) => {
      post('/logout')
        .then(() => {
// eslint-disable-next-line no-unused-expressions
          delete axios.defaults.headers.Authorization;
          context.commit('clearPermissions');
          router.push('/login');
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
